import {connect} from 'react-redux';
import EditAccountModal from './EditAccountModal.jsx';
import {
    handleEditAccountModalCancel,
    handleEditAccountModalSave
} from './actions';

const mapStateToProps = state => ({
  visible: state.finance.accounts.showEditAccountModal
});

const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch(handleEditAccountModalCancel()),
  onSubmit: data => dispatch(handleEditAccountModalSave(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(EditAccountModal);



// WEBPACK FOOTER //
// ./src/features/finance/accounts/EditAccountModalContainer.jsx